import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const useSubscriptionStore = create(
  devtools(
    (set) => ({
      loading: true,
      subscribed: undefined,
      onGracePeriod: undefined,
      plan: undefined,
      setLoading: () => set({ loading: true }),
      setSubscription: ({ subscribed, onGracePeriod, plan }) =>
        set({ loading: false, subscribed, onGracePeriod, plan }),
    }),
    { name: "useSubscriptionStore" }
  )
);
